module.exports = __webpack_public_path__ + "static/app-min-bdd6516f0dc50a86c12524c444754918.jpg";